import { NgModule } from '@angular/core';
import { windowProvider, WindowToken } from './window.provider';

@NgModule({
  providers: [
    { provide: WindowToken, useFactory: windowProvider },
  ]
})
export class ProvidersModule {}
